// ADINT - constelacao da canvasCtx de login
//
// Entry point PROPRIO do Vite (ver `vite.config.js`), no mesmo padrao de
// `phone.js` e `google2fa.js`: carregado com `@vite` na `@section('js')` de
// `resources/views/auth/login.blade.php`. Fora do `app.js` de proposito -- o
// `app.js` entra em TODA pagina, e este efeito so existe no login.
//
// Grafo de correlacao: nos que derivam devagar, arestas que aparecem quando
// dois nos ficam perto e, de tempos em tempos, um no "acende" como se tivesse
// casado com uma deteccao. E leitura do produto, nao enfeite solto -- por isso
// a aresta e o pulso usam a mesma teal da marca (#1884A3).
//
// Sem dependencia externa: puxar uma biblioteca de particulas custaria mais
// bytes do que o arquivo inteiro.

const canvas = document.querySelector('.cti-stage__net');

// O modulo e carregado so no login, mas a guarda fica: se o palco sair da
// blade, isto vira no-op em vez de estourar no console.
if (canvas?.getContext) {
    const ctx = canvas.getContext('2d');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

    const MIST = '233, 234, 238';
    const TEAL = '24, 132, 163';
    const SINAL = '87, 192, 220'; // teal clareada -- o no que acende

    const entre = (v, min, max) => Math.min(Math.max(v, min), max);

    let width = 0;
    let height = 0;
    let reach = 0;
    let nos = [];
    let frame = null;
    let proximoSinal = 0;

    // "Malware sendo destruido": de tempos em tempos um radius risca do topo ate
    // um no do lado direito (onde o painel de leitura ja diz "e aqui que a
    // operacao acontece") e o estilhaca. Aleatorio de proposito -- um intervalo
    // fixo pareceria metronomo, e o que deve incomodar e nao ter hora certa.
    let radius = null;
    let shards = [];
    let proximoRaio = 0;

    const mouse = { x: -1e4, y: -1e4, ativo: false };

    function resize() {
        // O dpr e limitado a 2: acima disso o ganho visual e nulo e o custo de
        // preencher o canvas cresce ao quadrado (num monitor 4k a 3x seriam
        // ~9x mais pixels por frame).
        const dpr = Math.min(window.devicePixelRatio || 1, 2);

        width = canvas.clientWidth || window.innerWidth;
        height = canvas.clientHeight || window.innerHeight;

        canvas.width = Math.round(width * dpr);
        canvas.height = Math.round(height * dpr);
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

        // Alcance da aresta pela diagonal, e nao fixo: num monitor largo um
        // valor fixo deixa a rede esparsa demais, e no celular, empastada.
        reach = entre(Math.sqrt(width * height) / 8, 100, 200);
    }

    const novoNo = () => ({
        x: Math.random() * width,
        y: Math.random() * height,
        vx: (Math.random() - 0.5) * 0.34,
        vy: (Math.random() - 0.5) * 0.34,
        r: 1 + Math.random() * 1.6,
        base: 0.36 + Math.random() * 0.4,
        cor: Math.random() < 0.24 ? TEAL : MIST,
        aceso: 0,
    });

    function povoar() {
        // Densidade por field, com teto: 140 nos custam ~10k pares por frame na
        // checagem de aresta, que e O(n^2) -- dobrar isso ja aparece no perfil.
        const quantidade = Math.round(entre((width * height) / 11000, 26, 140));

        nos = Array.from({ length: quantidade }, novoNo);
    }

    function mover() {
        for (const n of nos) {
            n.x += n.vx;
            n.y += n.vy;

            // Envolve as bordas em vez de quicar: quicar cria acumulo visivel
            // nos cantos depois de alguns segundos.
            if (n.x < -12) n.x = width + 12;
            if (n.x > width + 12) n.x = -12;
            if (n.y < -12) n.y = height + 12;
            if (n.y > height + 12) n.y = -12;

            if (n.aceso > 0) n.aceso -= 0.008;

            if (!mouse.ativo) continue;

            // Repulsao suave: o no se afasta do cursor sem perder a speed
            // propria, entao a rede volta ao normal sozinha quando o mouse sai.
            const dx = n.x - mouse.x;
            const dy = n.y - mouse.y;
            const dist = Math.hypot(dx, dy);

            if (dist > 0 && dist < 140) {
                const force = (1 - dist / 140) * 0.9;

                n.x += (dx / dist) * force;
                n.y += (dy / dist) * force;
            }
        }

        for (const e of shards) {
            e.x += e.vx;
            e.y += e.vy;
            e.vy += 0.02; // leve gravidade -- sem ela o estilhaco parece flutuar, nao explodir
            e.vida -= 0.025;
        }

        shards = shards.filter((e) => e.vida > 0);

        if (radius) {
            radius.vida -= 0.09;
            if (radius.vida <= 0) radius = null;
        }
    }

    function lightOne(agora) {
        if (agora < proximoSinal || nos.length === 0) return;

        nos[Math.floor(Math.random() * nos.length)].aceso = 1;
        proximoSinal = agora + 2200 + Math.random() * 3600;
    }

    function strike(agora) {
        if (agora < proximoRaio) return;

        // So no lado direito: reforca o painel de leitura em vez de brigar com
        // o selo e o card, que ficam a esquerda e ao centro.
        const targets = nos.filter((n) => n.x > width * 0.58);

        if (targets.length === 0) {
            proximoRaio = agora + 4000;

            return;
        }

        const target = targets[Math.floor(Math.random() * targets.length)];

        // Zigue-zague com poucos segmentos: o suficiente pra ler como radius, sem
        // virar rabisco. O deslocamento lateral encolhe a medida que desce, pra
        // convergir no target em vez de errar o reach dele.
        const points = [{ x: target.x + (Math.random() - 0.5) * 60, y: -20 }];
        const passos = 5;

        for (let i = 1; i <= passos; i++) {
            const t = i / passos;

            points.push({
                x: target.x + (Math.random() - 0.5) * 70 * (1 - t * 0.7),
                y: -20 + (target.y + 20) * t,
            });
        }

        radius = { points, vida: 1 };

        // O no atingido explode em shards e some; nasce outro em seu lugar
        // para a densidade da rede nao cair com o time.
        for (let i = 0; i < 9; i++) {
            const angle = Math.random() * Math.PI * 2;
            const vel = 0.6 + Math.random() * 1.6;

            shards.push({
                x: target.x,
                y: target.y,
                vx: Math.cos(angle) * vel,
                vy: Math.sin(angle) * vel,
                vida: 1,
            });
        }

        nos.splice(nos.indexOf(target), 1, novoNo());
        proximoRaio = agora + 4000 + Math.random() * 5000;
    }

    function traco(cor, alpha, ax, ay, bx, by) {
        ctx.strokeStyle = `rgba(${cor}, ${alpha.toFixed(3)})`;
        ctx.lineWidth = 1;
        ctx.beginPath();
        ctx.moveTo(ax, ay);
        ctx.lineTo(bx, by);
        ctx.stroke();
    }

    function draw() {
        ctx.clearRect(0, 0, width, height);

        // Arestas primeiro, para os nos ficarem por cima delas.
        for (let i = 0; i < nos.length; i++) {
            const a = nos[i];

            for (let j = i + 1; j < nos.length; j++) {
                const b = nos[j];
                const dx = a.x - b.x;
                const dy = a.y - b.y;
                const d2 = dx * dx + dy * dy;

                // Compara o quadrado com o quadrado para nao pagar uma raiz
                // quadrada por par -- so extrai a raiz nos pares que passam.
                if (d2 > reach * reach) continue;

                const d = Math.sqrt(d2);
                const strong = Math.max(a.aceso, b.aceso);

                traco(strong > 0 ? SINAL : TEAL,
                    (1 - d / reach) * (0.28 + strong * 0.45),
                    a.x, a.y, b.x, b.y);
            }

            // Aresta ate o cursor: e o que faz a rede parecer reagir a quem
            // esta olhando, sem tirar o clique do formulario.
            if (!mouse.ativo) continue;

            const md = Math.hypot(a.x - mouse.x, a.y - mouse.y);
            const limite = reach * 1.3;

            if (md < limite) {
                traco(MIST, (1 - md / limite) * 0.3, a.x, a.y, mouse.x, mouse.y);
            }
        }

        for (const n of nos) {
            ctx.fillStyle = `rgba(${n.aceso > 0 ? SINAL : n.cor}, ${Math.min(n.base + n.aceso * 0.5, 1).toFixed(3)})`;
            ctx.beginPath();
            ctx.arc(n.x, n.y, n.r + n.aceso * 1.2, 0, Math.PI * 2);
            ctx.fill();

            if (n.aceso <= 0) continue;

            // Anel do "hit": abre para fora enquanto apaga.
            ctx.strokeStyle = `rgba(${SINAL}, ${(n.aceso * 0.5).toFixed(3)})`;
            ctx.lineWidth = 1;
            ctx.beginPath();
            ctx.arc(n.x, n.y, n.r + (1 - n.aceso) * 26, 0, Math.PI * 2);
            ctx.stroke();
        }

        for (const e of shards) {
            ctx.fillStyle = `rgba(${SINAL}, ${e.vida.toFixed(3)})`;
            ctx.beginPath();
            ctx.arc(e.x, e.y, 1.4, 0, Math.PI * 2);
            ctx.fill();
        }

        if (radius) {
            // Brilho primeiro (traco largo e fraco), risco por cima (fino e
            // vivo) -- e o que da o halo de radius de verdade, nao so uma linha.
            ctx.lineJoin = 'round';
            ctx.strokeStyle = `rgba(${SINAL}, ${(radius.vida * 0.35).toFixed(3)})`;
            ctx.lineWidth = 6;
            ctx.beginPath();
            radius.pontos.forEach((p, i) => (i === 0 ? ctx.moveTo(p.x, p.y) : ctx.lineTo(p.x, p.y)));
            ctx.stroke();

            ctx.strokeStyle = `rgba(${SINAL}, ${radius.vida.toFixed(3)})`;
            ctx.lineWidth = 1.5;
            ctx.stroke();
        }
    }

    function loop(agora) {
        lightOne(agora);
        strike(agora);
        mover();
        draw();
        frame = window.requestAnimationFrame(loop);
    }

    function tocar() {
        if (frame !== null || reduced.matches) return;

        frame = window.requestAnimationFrame(loop);
    }

    function parar() {
        if (frame === null) return;

        window.cancelAnimationFrame(frame);
        frame = null;
    }

    function reiniciar() {
        resize();
        povoar();

        // Reseta o estado do radius no redimensionamento: sem isto um fragmento
        // nascido na width antiga poderia sobrar fora da canvasCtx nova.
        radius = null;
        shards = [];
        proximoRaio = performance.now() + 1500 + Math.random() * 2500;

        // Sem animacao a canvasCtx nao pode ficar vazia -- um frame parado ainda
        // entrega a textura da rede.
        if (reduced.matches) {
            draw();

            return;
        }

        tocar();
    }

    let defer = null;

    window.addEventListener('resize', () => {
        window.clearTimeout(defer);
        defer = window.setTimeout(reiniciar, 160);
    });

    // O ponteiro e ouvido no `window` porque o palco tem `pointer-events:none`
    // (ver `login.scss`): sem isso o canvas roubaria o clique no campo de
    // e-mail. As coordenadas ja sao de viewport, que e o sistema do canvas
    // `fixed`, entao nao ha conversao a fazer.
    window.addEventListener('mousemove', (e) => {
        mouse.x = e.clientX;
        mouse.y = e.clientY;
        mouse.ativo = true;
    });

    window.addEventListener('mouseout', (e) => {
        if (!e.relatedTarget) mouse.ativo = false;
    });

    // Sem isto o loop continua rodando com a aba em segundo plano, queimando
    // bateria numa canvasCtx que ninguem esta vendo.
    document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
            parar();
        } else {
            tocar();
        }
    });

    reduced.addEventListener('change', () => {
        parar();
        reiniciar();
    });

    reiniciar();
}
